// extracted by mini-css-extract-plugin
module.exports = {"root":"Prompt_root__NGHph","actionButton":"Prompt_actionButton__Q46LK","closeButton":"Prompt_closeButton__8lRzb","title":"Prompt_title__pmLMy"};